import { UPDATE_PAGING } from "./paginationActionTypes";

const INITIAL_STATE = {
  currentPage: 1,
  pageLimit: 10,
  totalItems: 0
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_PAGING:
      return {
        ...state,
        currentPage: action.payload.data.currentPage,
        totalItems: action.payload.data.total,
        pageLimit: action.payload.data.pageLimit
      };
    default:
      return state;
  }
};
